<template>
  <v-card outlined style="height: 500px;" class="d-flex align-center justify-center"
    @drop.prevent="onDrop($event)"
    @dragover.prevent="dragover = true"
    @dragenter.prevent="dragover = true"
    @dragleave.prevent="dragover = false"
    :class="{ 'grey lighten-4': dragover }"
    @click="$refs.file.click()"
  >
    <div class="d-flex flex-column align-center">
      <input type="file" ref="file" @change="onChange" accept="image/png, image/jpeg, image/gif, image/ico" style="display: none;" />

      <template v-if="!loading">
        <v-icon color="black" style="font-size: 5em;">mdi-cloud-upload</v-icon>
        <div class="font-weight-bold">
          Arraste e solte sua imagem aqui ou <span style="color: #0FA958">procure</span>
        </div>
        <span class="red--text mt-3 font-weight-bold">{{error}}</span>
      </template>
      <template v-else>
        <v-progress-circular
          :width="3"
          :size="60"
          color="secondary"
          indeterminate
        ></v-progress-circular>
        <strong class="mt-5">Estamos enviando sua imagem :)</strong>
        <span>Por favor, aguarde...</span>
      </template>
    </div>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import CloudFunctionService from '@/services/CloudFunctionService'

export default {
  data () {
    return {
      file: null,
      dragover: false,
      error: null,
      loading: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    async upload (file = this.file) {
      this.loading = true

      try {
        const url = await CloudFunctionService.upload({ image: file, userId: this.user.id })
        this.$emit('save', url)
        this.$emit('input', false)
      } catch (e) {
        console.error(e)
      }

      this.loading = false
    },
    onChange (e) {
      const file = e.target.files[0]

      if (file) {
        this.upload(file)
      }
    },
    onDrop (e) {
      this.dragover = false
      this.error = null

      if (e.dataTransfer.files.length > 1) {
        return this.error = 'Por favor, selecione apenas um arquivo.'
      }

      return this.upload(e.dataTransfer.files[0])
    }
  }
}
</script>

<style lang="scss" scoped>

</style>